// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.term-head {
  position: relative;
}
.term-head:before {
  top: 50%;
  left: 50%;
  color: #fff;
  width: 50%;
  font-size: 3rem;
  content: "Privacy Policy";
  font-weight: bold;
  position: absolute;
  padding: 10px 40px;
  text-align: center;
  text-transform: uppercase;
  background: rgba(0, 0, 0, 0.5);
  transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}

.termImage {
  width: 100vw;
  height: 300px !important;
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/pages/general/privacyPolicy/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;EAChC,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;AACnB","sourcesContent":[".term-head {\n  position: relative;\n}\n.term-head:before {\n  top: 50%;\n  left: 50%;\n  color: #fff;\n  width: 50%;\n  font-size: 3rem;\n  content: \"Privacy Policy\";\n  font-weight: bold;\n  position: absolute;\n  padding: 10px 40px;\n  text-align: center;\n  text-transform: uppercase;\n  background: rgba(0, 0, 0, 0.5);\n  transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n}\n\n.termImage {\n  width: 100vw;\n  height: 300px !important;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
